module.exports = __webpack_public_path__ + "img/subBanner13.36f42214.png";